import { render, staticRenderFns } from "./VendedorUpdate.vue?vue&type=template&id=b535d350&"
import script from "./VendedorUpdate.vue?vue&type=script&lang=js&"
export * from "./VendedorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports